import { CloseIcon, CloseIconWrapper, FileName, Menu, Wrapper } from './PreviewPDFModal.style';
import { ModalProps } from 'components/Dialogs/types';
import { useAppSelector } from 'store/hooks';
import { selectNewFiles } from 'store/features/newFiles/selectors';
import Modal from '@mui/material/Modal';
import Tooltip from '@mui/material/Tooltip';
import { FilePreview } from 'components/Dialogs/PreviewPDFModal/pagePreview';

const PreviewPDFModal = ({ toggleModalOpen, actualPageId: blobURL }: ModalProps) => {
    const newFiles = useAppSelector(selectNewFiles);
    const file = newFiles.filter(file => file.blobURL === blobURL)[0];
    return (
        <Modal open={true}>
            <Wrapper>
                <Menu>
                    <Tooltip title={file.filename}>
                        <FileName>{file.filename}</FileName>
                    </Tooltip>
                    <CloseIconWrapper>
                        <CloseIcon onClick={() => toggleModalOpen('save')} />
                    </CloseIconWrapper>
                </Menu>
                <FilePreview fileName={file.filename} url={blobURL as string} pdfViewMethod='iframes' />
            </Wrapper>
        </Modal>
    );
};

export default PreviewPDFModal;
